import { Button } from 'antd'
import React from 'react'
import styled from 'styled-components/macro'

/**
 * In-place recipes GP walkthrough. Not a second page and not its own modal.
 */
const GrowthEngineRecipesWalkthrough = ({
  step,
  stepIndex = 0,
  stepCount = 0,
  needsResume = false,
  isLast = false,
  onNext,
  onSkip,
  onResume,
  allowNext = true,
  showStepCount = true,
  className,
  'data-testid': dataTestId = 'growth-engine-recipes-walkthrough',
}) => {
  if (!step?.title) return null

  const showNext = Boolean(allowNext && onNext && !needsResume)

  return (
    <Wrap
      className={className}
      data-testid={dataTestId}
      role='region'
      aria-label='Cost your first dish'
    >
      {showStepCount && stepCount ? (
        <StepCount data-testid='guided-walkthrough-step-count'>
          Step {stepIndex + 1} of {stepCount}
        </StepCount>
      ) : null}
      <Title data-testid='guided-walkthrough-title'>{step.title}</Title>
      {step.body ? (
        <Body data-testid='guided-walkthrough-body'>{step.body}</Body>
      ) : null}
      <Actions>
        {needsResume && onResume ? (
          <Button
            type='primary'
            onClick={onResume}
            data-testid='guided-walkthrough-resume'
          >
            Resume
          </Button>
        ) : showNext ? (
          <Button
            type='primary'
            onClick={onNext}
            data-testid='guided-walkthrough-next'
          >
            {isLast ? 'Got it' : 'Next'}
          </Button>
        ) : null}
        {onSkip ? (
          <Skip
            type='button'
            onClick={onSkip}
            data-testid='guided-walkthrough-skip'
          >
            Skip for now
          </Skip>
        ) : null}
      </Actions>
    </Wrap>
  )
}

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 8px 16px;
`

const StepCount = styled.p`
  color: ${({ theme }) => theme.colours.oliveGrey || '#8c8c8c'};
  font-size: 12px;
  font-weight: 600;
  margin: 0;
`

const Title = styled.h3`
  color: ${({ theme }) => theme.colours.bbqBlack || '#262626'};
  font-size: 15px;
  font-weight: 600;
  line-height: 1.35;
  margin: 0;
`

const Body = styled.p`
  color: ${({ theme }) => theme.colours.oliveGrey || '#595959'};
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
`

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-top: 4px;
`

const Skip = styled.button`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colours.oliveGrey || '#8c8c8c'};
  cursor: pointer;
  font-size: 13px;
  padding: 4px 0;
  text-decoration: underline;

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colours.bbqBlack || '#262626'};
  }
`

export default GrowthEngineRecipesWalkthrough
